import { Component, inject, signal } from '@angular/core';
import { KcButtonComponent } from '@kaspacom/ui-kit';
import { WalletManager } from '../../managers/wallet.manager';

@Component({
  selector: 'kcc20-cookie-consent-modal',
  standalone: true,
  imports: [KcButtonComponent],
  templateUrl: './cookie-consent-modal.component.html',
  styleUrl: './cookie-consent-modal.component.scss',
})
export class CookieConsentModalComponent {
  readonly walletManager = inject(WalletManager);
  readonly additionalCookies = signal(false);

  accept(): void {
    localStorage.setItem('cookiesConsent', 'accepted');
    localStorage.setItem('strictlyNecessaryCookies', 'true');
    localStorage.setItem(
      'additionalCookies',
      this.additionalCookies().toString(),
    );
    this.walletManager.showCookieConsentModal.set(false);
    this.walletManager.showLoginModal();
  }

  cancel(): void {
    localStorage.setItem('cookiesConsent', 'denied');
    this.walletManager.showCookieConsentModal.set(false);
  }
}
